// This code extracted from: https://github.com/fernandopasik/react-children-utilities

import type { ReactElement } from 'react';
import { Children, isValidElement, type ReactNode } from 'react';

const hasChildren = (element: ReactNode): element is ReactElement<{ children: ReactNode | ReactNode[] }> =>
  isValidElement<{ children?: ReactNode[] }>(element) && Boolean(element.props.children);

const childToString = (child?: ReactNode): string => {
  if (typeof child === 'undefined' || child === null || typeof child === 'boolean') {
    return '';
  }

  if (JSON.stringify(child) === '{}') {
    return '';
  }

  return (child as number | string).toString();
};

export const onlyTextChildren = (children: ReactNode | ReactNode[]): string => {
  if (!(children instanceof Array) && !isValidElement(children)) {
    return childToString(children);
  }

  return Children.toArray(children).reduce<string>((text: string, child: ReactNode): string => {
    let newText = '';

    if (hasChildren(child)) {
      newText = onlyTextChildren(child.props.children);
    } else if (isValidElement(child)) {
      newText = '';
    } else {
      newText = childToString(child);
    }

    return text.concat(newText);
  }, '');
};
